import DoubleUploadImgType from "./components/DoubleUploadImg/default";
import inputType from './components/input/default';
import switchType from './components/switch/default';
import selectType from './components/select/default';
import passwordType from './components/password/default';
import digitType from './components/digit/default';
import moneyType from './components/money/default';
import textareaType from './components/textarea/default';
import dateType from './components/date/default';
import dateTimeType from "./components/dateTime/default"
import dateTimeRangeType from "./components/dateTimeRange/default"
import dateRangeType from './components/dateRange/default';
import BankCardNumberType from "./components/BankCardNumber/default"
import inputSearchType from "./components/inputSearch/default"
import UploadImgType from "./components/UploadImg/default"
import groupType from "./components/Group/default"
import tableType from "./components/TableWapper/default"
import modalType from "./components/ModalWapper/default"
import radioType from "./components/Radio/default"
import BottomSubButtonType from "./components/BottomSubButton/default"
import ColorPickerType from "./components/ColorPicker/default";
import mobileType from "./components/mobileWapper/default"
import checkboxType from "./components/Checkbox/default"


export const ConType = (type: string) => {
  return {
    checkbox: checkboxType(),
    dateTime: dateTimeType(),
    dateTimeRange: dateTimeRangeType(),
    text: inputType(),
    switch: switchType(),
    select: selectType(),
    password: passwordType(),
    digit: digitType(),
    money: moneyType(),
    textarea: textareaType(),
    date: dateType(),
    dateRange: dateRangeType(),
    DoubleUploadImg: DoubleUploadImgType(),
    IDCard: DoubleUploadImgType("IDCard"),
    BankCardNumber: BankCardNumberType(),
    inputSearch: inputSearchType(),
    UploadImg: UploadImgType(),
    "@group": groupType(),
    table: tableType(),
    modal: modalType(),
    radio: radioType(),
    BottomSubButton: BottomSubButtonType(),
    ColorPicker: ColorPickerType(),
    mobile: mobileType()
  }[type];
};
// SearchFormComponents
export const SearchFormComponents = [
  {
    valueType: "text",
    label: "文本输入框"
  },
  {
    valueType: "select",
    label: "下拉选择"
  },
  {
    valueType: "switch",
    label: "开关"
  }
  , {
    valueType: "password",
    label: "密码输入框"
  }
  , {
    valueType: "digit",
    label: "数字输入框"
  }, {
    valueType: "money",
    label: "金钱输入框"
  }, {
    valueType: "date",
    label: "日期选择器"
  }, {
    valueType: "dateTime",
    label: "日期时间选择器"
  },
  {
    valueType: "dateRange",
    label: "日期区间选择器"
  }, {
    valueType: "dateTimeRange",
    label: "日期时间区间选择器"
  },
  {
    valueType: "inputSearch",
    label: "输入搜索框"
  },
  {
    valueType: "radio",
    label: "单选框"
  },
  {
    valueType: "checkbox",
    label: "复选框"
  }
]

export const ComTypeClass = [
  {
    name: "基础表单组件",
    components: [{
      valueType: "text",
      label: "文本输入框"
    },
    {
      valueType: "select",
      label: "下拉选择"
    },
    {
      valueType: "switch",
      label: "开关"
    }
      , {
      valueType: "password",
      label: "密码输入框"
    }
      , {
      valueType: "digit",
      label: "数字输入框"
    }
      , {
      valueType: "money",
      label: "金钱输入框"
    },
    {
      valueType: "textarea",
      label: "文本域"
    }, {
      valueType: "date",
      label: "日期选择器"
    }, {
      valueType: "dateTime",
      label: "日期时间选择器"
    },
    {
      valueType: "dateRange",
      label: "日期区间选择器"
    }, {
      valueType: "dateTimeRange",
      label: "日期时间区间选择器"
    },
    {
      valueType: "inputSearch",
      label: "输入搜索框"
    },
    {
      valueType: "radio",
      label: "单选框"
    }, {
      valueType: "checkbox",
      label: "复选框"
    }
    ]
  },
  {
    name: "复合组件",
    components: [
      {
        valueType: "BankCardNumber",
        label: "银行卡号"
      },
      {
        valueType: "@group",
        label: "组"
      },
      {
        valueType: "DoubleUploadImg",
        label: "双图上传"
      },
      {
        valueType: "IDCard",
        label: "身份证上传"
      },
      {
        valueType: "UploadImg",
        label: "单图上传"
      },
      {
        valueType: "table",
        label: "表格"
      },
      {
        valueType: "BottomSubButton",
        label: "底部操作"
      },
      {
        valueType: "ColorPicker",
        label: "颜色选择器"
      }
    ]
  }
]